import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'de',
  messages: {
    de: {
      'Top-Händler - Von rewaco ausgezeichneter Kundenservice.': 'Top-Händler - Von rewaco für seinen Kundenservice ausgezeichneter Händler.',
      'consent.maps.title': 'Einwilligung fur Google Maps erforderlich',
      'consent.maps.description': 'Die Handlersuche verwendet Google Maps und Google Places. Diese Dienste werden erst nach Ihrer Einwilligung geladen.',
      'consent.maps.declaration': 'Mit Klick auf "Ich stimme zu" willigen Sie ein, dass Daten (z. B. Ihre IP-Adresse und eingegebene Standortdaten) an Google ubermittelt werden konnen.',
      'consent.maps.accept': 'Ich stimme zu und Karte laden'
    },
    en: {
      'Suche nach PLZ, Ort': 'Search by postcode, city',
      'Kontakt': 'Contact',
      'Alle': 'All',
      'Leider ist ein Fehler aufgetreten': 'Sorry, an error has occurred',
      'Bitte versuche es zu einem späteren Zeitpunkt erneut': 'Please try it later again',
      'Dein Name': 'Your name',
      'Deine E-Mail': 'Your email',
      'Deine Telefonnummer': 'Your telephone number',
      'Deine Nachricht': 'Your message',
      'Gewünschtes Abhol- Abgabedatum (Von-Bis)': 'Desired date (From-To)',
      'Von': 'From',
      'Bis': 'To',
      'Können Sie mich bitte zurückrufen?': 'Can you please call me back?',
      'Bieten Sie Finanzierungsmöglichkeiten an?': 'Do you offer financing options?',
      'Können bei Ihnen Helme geliehen werden?': 'Can helmets be rented from you?',
      'Können auch 2 Beifahrer mitgenommen werden?': 'Can 2 co-drivers also be taken along?',
      'Ich stimme der Verarbeitung meiner Daten zu.': 'I agree to the processing of my data.',
      'Kopie an mich senden': 'Send a copy to me',
      'Datenschutzerklärung': 'Privacy policy',
      'Nachricht senden': 'Send message',
      'Top-Händler - Von rewaco ausgezeichneter Kundenservice.': 'Top-Dealer - Dealer awarded by rewaco for its customer service.',
      'Top-Händler': 'Top-Dealer',
      'Weitere Händler anzeigen': 'More',
      'Nachricht an': 'Message to',
      'Allgemein': 'General',
      'Verkauf': 'Sale',
      'Vermietung': 'Rent',
      'Service': 'Service',
      'Fahrzeugangebot des Händlers': 'Dealer\'s vehicle offer',
      'Nachricht senden': 'Send message',
      'Betreff': 'Subject',
      'Persönlicher Text': 'Your personal text',
      'Ich möchte einen Dreisitzer mieten': 'I would like to rent a three-seater',
      'Ich möchte einen Zweisitzer mieten': 'I would like to rent a two-seater',
      'Keine Händler gefunden.': 'No dealers found.',
      'Deine Nachricht wurde bereits erfolgreich gesendet': 'Your message has already been successfully sent',
      'consent.maps.title': 'Consent required for Google Maps',
      'consent.maps.description': 'Dealer search uses Google Maps and Google Places. These services are only loaded after your consent.',
      'consent.maps.declaration': 'By clicking "I consent", you agree that data (for example your IP address and entered location) may be transmitted to Google.',
      'consent.maps.accept': 'I consent and load map'
    },
    fr: {
      'Suche nach PLZ, Ort': 'Recherche par code postal, ville',
      'Kontakt': 'Contact',
      'Alle': 'All',
      'Leider ist ein Fehler aufgetreten': 'Désolé, une erreur s\'est produite',
      'Bitte versuche es zu einem späteren Zeitpunkt erneut': 'Please try it later again',
      'Dein Name': 'Votre nom',
      'Deine E-Mail': 'Votre email',
      'Deine Telefonnummer': 'Votre téléphone',
      'Deine Nachricht': 'Votre message',
      'Gewünschtes Abhol- Abgabedatum (Von-Bis)': 'Desired date (From-To)',
      'Von': 'From',
      'Bis': 'To',
      'Können Sie mich bitte zurückrufen?': 'Can you please call me back?',
      'Bieten Sie Finanzierungsmöglichkeiten an?': 'Do you offer financing options?',
      'Können bei Ihnen Helme geliehen werden?': 'Can helmets be rented from you?',
      'Können auch 2 Beifahrer mitgenommen werden?': 'Can 2 co-drivers also be taken along?',
      'Ich stimme der Verarbeitung meiner Daten zu.': 'J\'accepte le traitement de mes données.',
      'Kopie an mich senden': 'Send a copy to me',
      'Datenschutzerklärung': 'Privacy policy',
      'Nachricht senden': 'Send message',
      'Top-Händler - Von rewaco ausgezeichneter Kundenservice.': 'Top-Dealer - Dealer awarded by rewaco for its customer service.',
      'Top-Händler': 'Top-Dealer',
      'Weitere Händler anzeigen': 'Charger plus',
      'Nachricht an': 'Message to',
      'Allgemein': 'General',
      'Verkauf': 'Vente',
      'Vermietung': 'Location',
      'Service': 'Service',
      'Fahrzeugangebot des Händlers': 'Dealer\'s vehicle offer',
      'Nachricht senden': 'Envoyer message',
      'Betreff': 'Sujet',
      'Persönlicher Text': 'Your personal text',
      'Ich möchte einen Dreisitzer mieten': 'I would like to rent a three-seater',
      'Ich möchte einen Zweisitzer mieten': 'I would like to rent a two-seater',
      'Keine Händler gefunden.': 'No dealers found.',
      'Deine Nachricht wurde bereits erfolgreich gesendet': 'Your message has already been successfully sent',
      'consent.maps.title': 'Consentement requis pour Google Maps',
      'consent.maps.description': 'La recherche de concessionnaires utilise Google Maps et Google Places. Ces services ne sont charges qu apres votre consentement.',
      'consent.maps.declaration': 'En cliquant sur "Je consens", vous acceptez que des donnees (par ex. votre adresse IP et la localisation saisie) puissent etre transmises a Google.',
      'consent.maps.accept': 'Je consens et charger la carte'
    },
  }
});
